// @ vendors
const Immutable = require('immutable');
const { pick } = require('lodash');

// @ constants
const actionTypes = require('../insuranceConstants/actionTypes');
const { DOCUMENT_TYPES } = require('../insuranceConstants/insuranceRequestHome');

const docTypes = pick(DOCUMENT_TYPES, [DOCUMENT_TYPES.POLICY, DOCUMENT_TYPES.BUDGET]);

const setInitialState = () => {
    const documentsFetch = Object.keys(docTypes).map(() => {
        return {
            isFetching: false,
            error: ''
        }
    });

    return Immutable.Map().merge({
        isFetching: false,
        documentDownloadingPolicyNumber: '-1',
        insuranceContractedPolicy: [],
        documentsFetch
    });
};

const insurancesProfileDocumentation = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.FETCH_CONTRACTED_POLICY_REQUEST:
            return state.merge({
                isFetching: true
            });

        case actionTypes.FETCH_CONTRACTED_POLICY_SUCCESS:
            return state.merge({
                insuranceContractedPolicy: action.payload.data,
                error: '',
                isFetching: false
            });

        case actionTypes.FETCH_CONTRACTED_POLICY_FAILURE:
            return state.merge({
                error: action.payload.error,
                isFetching: false
            });

        case actionTypes.FETCH_CONTRACTED_POLICY_PDF_REQUEST:
            return state.merge({
                documentsFetch: {
                    [action.payload.docType]: { isFetching: true }
                },
                documentDownloadingPolicyNumber: action.payload.documentDownloadingPolicyNumber
            });

        case actionTypes.FETCH_CONTRACTED_POLICY_PDF_FINISHED:
            return state.merge({
                documentsFetch: {
                    [action.payload.docType]: { isFetching: false }
                },
                documentDownloadingPolicyNumber: '-1'
            });

        default:
            return state
    }
};

module.exports = insurancesProfileDocumentation;
